module.exports = __webpack_public_path__ + "static/media/intro.07df121c.mp3";